// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --dl-color-monaco-string-escape: #d7ba7d;
  --dl-color-monaco-date: #42a807;
  --dl-color-monaco-field: #964218;
}

.monaco-editor.vs-dark .view-overlays .current-line {
  border-color: var(--g-color-line-generic);
}

.g-root .monaco-aria-container {
  left: -999em !important;
  margin: -1px;
  padding: 0;
  clip-path: inset(50%);
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/dl-monaco.scss"],"names":[],"mappings":"AAAA;EACI,wCAAA;EACA,+BAAA;EACA,gCAAA;AACJ;;AAEA;EACI,yCAAA;AACJ;;AAMI;EAEI,uBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AAJR","sourcesContent":[":root {\n  --dl-color-monaco-string-escape: #d7ba7d;\n  --dl-color-monaco-date: #42a807;\n  --dl-color-monaco-field: #964218;\n}\n\n.monaco-editor.vs-dark .view-overlays .current-line {\n  border-color: var(--g-color-line-generic);\n}\n\n.g-root .monaco-aria-container {\n  left: -999em !important;\n  margin: -1px;\n  padding: 0;\n  clip-path: inset(50%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
